import SubfolderCard from './SubfolderCard';
import SubfolderCardContainer from './SubfolderCard.container';

export default SubfolderCardContainer(SubfolderCard);
